export enum SearchSessionsTypes {
  SearchSessionsRequest = 'SearchService.SearchSessions.Request',
  SearchSessionsSuccess = 'SearchService.SearchSessions.Success',
  SearchSessionsFailure = 'SearchService.SearchSessions.Failure',
  SessionMarkersRequest = 'SearchService.SessionMarkers.Request',
  SessionMarkersSuccess = 'SearchService.SessionMarkers.Success',
  SessionMarkersFailure = 'SearchService.SessionMarkers.Failure',
  SearchPreviewsRequest = 'SearchService.SearchPreviews.Request',
  SearchPreviewsSuccess = 'SearchService.SearchPreviews.Success',
  SearchPreviewsFailure = 'SearchService.SearchPreviews.Failure',
}
